export function resolveProjectBreadcrumbRoute(pathname: string) {
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] === "project" && segments[1]) {
    const isBoard = segments[2] === "tasks" && segments[3] !== undefined;
    return {
      projectTo: `/project/${segments[1]}`,
      boardId: isBoard ? segments[3] : segments[1],
      section: isBoard ? "Tasks" : null,
    };
  }
  if (segments[0] === "cmmd" && segments[1] === "project") {
    return { projectTo: `/project/${segments[2]}`, boardId: segments[2], section: null };
  }
  return null;
}
